import { isAuthenticated } from '../utils/auth';
import { useState, useEffect } from 'react';
import datascienceandai from '../images/datascienceandai.png';
import erp from '../images/erp.png';
import productengineeringandservices from '../images/productengineeringandservices.png';
import hardwareandvalidation from '../images/hardwareandvalidation.png';
import H1BSTAFF from '../images/H1BSTAFF.png';
import salesforce from '../images/salesforce.png';
import dsil from '../images/dsil.png';
import entierpriseandarchitecture from '../images/entierpriseandarchitecture.png';
import { apiFetch } from '../utils/api';

const useDepartments = () => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isAuthenticated()) return;
    const fetchDepartments = async () => {
      try {
        setLoading(true);
        setError(null);

        const data = await apiFetch(`${window._env_.API_BASE_URL}/departments/summary`);

        // Transform the API data to match the expected format
        const transformedData = data.map(dept => ({
          id: dept.department_id,
          name: dept.department_name,
          description: dept.description,
          courses: dept.course_count,
          learners: dept.enroller_count,
          image: getDepartmentImage(dept.department_name),
          icon: getDepartmentIcon(dept.department_name),
          color: getDepartmentColor(dept.department_name),
        }));

        setDepartments(transformedData);
      } catch (err) {
        console.error('Error fetching departments:', err);
        setError(err.message);
        setDepartments([]); // fallback
      } finally {
        setLoading(false);
      }
    };

    fetchDepartments();
  }, []);

  // Helper function to assign images based on department name
  const getDepartmentImage = (departmentName) => {
    const imageMap = {
      'Data Science and AI': datascienceandai,
      'Data Science & AI': datascienceandai,
      'Datascience&AI': datascienceandai,
      'ERP Applications': erp,
      'ERP APPLICATION': erp,
      'Product Engineering Services': productengineeringandservices,
      'Product Engineering services': productengineeringandservices,
      'Hardware and Validation': hardwareandvalidation,
      'Hardware and validation': hardwareandvalidation,
      'H1B Staffing': H1BSTAFF,
      'H1B STAFFING': H1BSTAFF,
      'Salesforce': salesforce,
      'DSIL': dsil,
      'Enterprise Architecture': entierpriseandarchitecture
    };
    return imageMap[departmentName] || datascienceandai; // Default fallback
  };

  // Helper function to assign icons based on department name
  const getDepartmentIcon = (departmentName) => {
    const iconMap = {
      'Data Science and AI': '🧠',
      'Data Science & AI': '🧠',
      'Datascience&AI': '🧠',
      'ERP Applications': '📈',
      'ERP APPLICATION': '📈',
      'Product Engineering Services': '💻',
      'Product Engineering services': '💻',
      'Hardware and Validation': '🔧',
      'Hardware and validation': '🔧',
      'H1B Staffing': '👥',
      'H1B STAFFING': '👥',
      'Salesforce': '☁️',
      'DSIL': '🏢',
      'Enterprise Architecture': '🏗️'
    };
    return iconMap[departmentName] || '📚';
  };

  // Helper function to assign colors based on department name
  const getDepartmentColor = (departmentName) => {
    const colorMap = {
      'Data Science and AI': '#2d7dd2',
      'Data Science & AI': '#2d7dd2',
      'Datascience&AI': '#2d7dd2',
      'ERP Applications': '#f6b93b',
      'ERP APPLICATION': '#f6b93b',
      'Product Engineering Services': '#6a1b9a',
      'Product Engineering services': '#6a1b9a',
      'Hardware and Validation': '#ff6b35',
      'Hardware and validation': '#ff6b35',
      'H1B Staffing': '#4ecdc4',
      'H1B STAFFING': '#4ecdc4',
      'Salesforce': '#00a1e0',
      'DSIL': '#95a5a6',
      'Enterprise Architecture': '#e74c3c'
    };
    return colorMap[departmentName] || '#007bff';
  };

  return { departments, loading, error };
};

export default useDepartments;